// Categorias.js
import React, { useEffect, useState } from "react";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import Table from "../../components/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useParams, useNavigate } from "react-router-dom";
import { ModalNuevaCategoria } from "../../components/empresa_uno_comp/ModalNuevaCategoria";

import { ApiService } from "../../components/ApiService";
import { Button, CircularProgress, Box, Typography } from "@mui/material";
import LupaIcon from "../../svg/lupaIcon";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";

export const Categorias = ({ selectedSucursal, permisos }) => {
	const navigate = useNavigate();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	const handleOpenModal = () => setIsModalOpen(true);
	const handleCloseModal = () => setIsModalOpen(false);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	// Columnas de la tabla
	const columns = [
		{
			name: "N°",
			selector: (row, index) => index + 1,
			sortable: true,
		},
		{
			name: "Categoría",
			selector: (row) => row.name,
			sortable: true,
		},
		{
			name: "Descripción",
			cell: (row) => (
				<div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
					{row.definition || "Sin descripción"}
				</div>
			),
			sortable: true,
		},
	];
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);

	// Función para obtener las categorías
	const fetchCategories = async () => {
		// Only set loading if this component is the one currently displayed
		setLoading(true);
		try {
			const url = `api/company/category/list?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };
			const response = await ApiService.fetchData(url, options);
			if (!response) {
				throw new Error("Error al cargar las categorías");
			}
			const formattedData = Array.isArray(response) ? response : response.data || [];
			setData(formattedData);
			setFilteredData(formattedData);
		} catch (error) {
			console.error("Error al cargar las categorías:", error);
		} finally {
			// Only update loading state if we're still on this page
			setLoading(false);
		}
	};
	// 3. Fix the data fetching to prevent state updates after unmounting
	useEffect(() => {
		if (permisos?.leer) {
			fetchCategories();
		}
	}, [selectedSucursal]);

	// Función para manejar cuando se agrega una nueva categoría
	const handleCategoryAdded = () => {
		fetchCategories();
	};

	useEffect(() => {
		if (search.length > 1) {
			const filtered = data.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
			setFilteredData(filtered);
		} else {
			setFilteredData(data);
		}
	}, [search, data]);

	return (
		<>
			<div className="functionality-container">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Categorías</h2>
				</div>

				<SearchCompany theme={'var(--theme-company)'} valor={search} setValor={(event)=>setSearch(event.target.value)} placeholder="Categorias"/>

				{/* Only show Add Category button if user has permission */}
				{permisos?.editar && (
					<div className="content-btn-add">
						<Button
							variant="contained"
							onClick={handleOpenModal}
							sx={{ fontWeight: "bold", letterSpacing: "1px", backgroundColor: 'var(--theme-company)' }}>
							Nueva Categoría
						</Button>
					</div>
				)}
			</div>
			<div className="datatable-container">
				{loading ? (
					<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
						<Box sx={{ textAlign: "center" }}>
							<CircularProgress />
							<Typography variant="body1" sx={{ mt: 2 }}>
								Cargando permisos...
							</Typography>
						</Box>
					</Box>
				) : (
					currentSize > 480 ? (
						<div className="table-view-pc">
							<Table columns={columns} data={filteredData} />
						</div>
					) : (
						<TablesMobile filteredData={(filteredData ?? []).map(obj => ({
							img: null,
							title: obj?.name,
							texto: obj?.definition ?? "Sin Definición...",
							fullPhone: null,
						}))} whatsapp={false} />
					)
				)}
			</div>
			{/* Only render the modal if user has permission to add categories */}
			{
				permisos?.editar && isModalOpen && (
					<ModalNuevaCategoria
						isOpen={isModalOpen}
						onClose={handleCloseModal}
						onCategoryAdded={handleCategoryAdded}
						selectedSucursal={selectedSucursal}
					/>
				)
			}
		</>
	);
};
